import React from 'react'
import { useConfig } from 'customer/routes'
import styled from 'styled-components'
import { styleTheme } from '../../style/theme'

import { ContactCompleteProps } from './ContactComplete.types'

type Config = {
  thanksMessage: string
}

export const ContactCompletePage: React.FC = () => {
  const config = useConfig() as Config

  return <StyledPage thanksMessage={config.thanksMessage} />
}

const Page: React.FC<ContactCompleteProps> = ({ className, thanksMessage }) => {
  return (
    <div className={className}>
      <pre>{thanksMessage}</pre>
    </div>
  )
}

const StyledPage = styled(Page)`
  max-width: 768px;
  margin: 0 auto;
  color: ${styleTheme.colors.black};
  background-color: ${styleTheme.colors.white};
  padding: 32px 16px;
  font-size: 14px;
  line-height: 1.8;
`
